export default {
  path: 'aggregator/requests/:id',
  name: 'Aggregator_requests_details',
  meta: {
    parent_vue_name: 'Aggregator_requests',
    breadcrumb_value: 'road-maintenance.requests',
    redirectViewName: 'Aggregator_requests'
  },
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../../common/views/AggregatorDetails.vue')
}
